import { auditActionLabel } from "@/shared/audit/catalog";

export interface SecurityNotice {
  id: string;
  category: string;
  event_type: string;
  summary: string;
  read_at?: string | null;
  created_at: string;
}

type Translate = (key: "notices.newDevice" | "notices.passwordChanged" | "notices.passwordReset" | "notices.passwordResetByAdmin" | "notices.policyChanged" | "notices.unknown" | "notices.developerSubmitted" | "notices.developerApproved" | "notices.developerRejected" | "notices.developerRejectedReason" | "notices.developerRevoked" | "notices.developerRevokedReason", values?: Record<string, string | number>) => string;

export function noticeText(item: SecurityNotice, t: Translate): string {
  switch (item.event_type) {
    case "auth.login_success":
    case "federation.login_success":
      return t("notices.newDevice", { device: deviceSummary(item.summary, t("notices.unknown")) });
    case "user.password_reset":
      return t("notices.passwordReset");
    case "user.password_reset_by_admin":
      return t("notices.passwordResetByAdmin");
    case "user.password_changed":
      return t("notices.passwordChanged");
    case "tenant.security_policy_updated":
      return t("notices.policyChanged");
    case "developer.application_submitted":
      return t("notices.developerSubmitted", { applicant: item.summary || t("notices.unknown") });
    case "developer.application_approved":
      return t("notices.developerApproved");
    case "developer.application_rejected":
      return item.summary ? t("notices.developerRejectedReason", { reason: item.summary }) : t("notices.developerRejected");
    case "developer.role_revoked":
      return item.summary ? t("notices.developerRevokedReason", { reason: item.summary }) : t("notices.developerRevoked");
    default: {
      const summary = item.summary.trim();
      if (!summary || summary === item.event_type) return item.event_type;
      return summary;
    }
  }
}

export function noticeTitle(item: SecurityNotice, t: Translate, locale: "zh-CN" | "en"): string {
  const text = noticeText(item, t);
  if (text === item.event_type) return auditActionLabel(item.event_type, locale);
  return text;
}

function deviceSummary(summary: string, unknown: string) {
  const value = summary.trim();
  const lower = value.toLowerCase();
  if (!value || lower === "unknown" || lower === "unknown device") return unknown;
  return value;
}
